import { useGetBestPracticeLazyQuery, OnResultDocument } from "../generated";

import { useApolloClient } from "@apollo/client";
import { useEffect } from "react";
import useNewrelic from "./useNewrelic";

const useBestPracticeSubscription = ({
  checkType,
  checkId,
  resource,
  description,
  fileFormat,
  setLoading,
  setBestPracticeCode,
}: any) => {
  const client = useApolloClient();
  const { noticeError, log } = useNewrelic();
  const [getBestPractice, { data, loading, error, called, refetch }] =
    useGetBestPracticeLazyQuery({
      variables: {
        checkType,
        checkId,
        resource,
        description,
        fileFormat,
      },
      context: {
        apiName: "template_scanner",
      },
    });

  useEffect(() => {
    if (error) {
      noticeError(error, "useGetBestPracticeResponse");
    }
    if (data?.getBestPractice?.uuid) {
      client
        ?.subscribe({
          query: OnResultDocument,
          variables: {
            id: data?.getBestPractice?.uuid,
          },
        })
        .subscribe(
          async ({ data }: any) => {
            const url = data?.onResult?.result;
            let res = await fetch(url);
            let bestPractice = await res.text();
            setBestPracticeCode(bestPractice);
            setLoading(false);
          },
          (error: any) => {
            noticeError(error, "useGetBestPracticeResponse");
          },
          () => {
            log("completed subscription");
          }
        );
    }
  }, [data, called, getBestPractice, error]);

  return { loading, getBestPractice, refetch };
};

export default useBestPracticeSubscription;
